import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import XHR from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';
const en = require('./locales/en_US.json');
const jp = require('./locales/ja_JP.json');

const resources = {
    en: { translation: en },
    ja: { translation: jp },
};

function loadLocales(url, options, callback, data) {
    try {
        const locale = require(`./${url}.json`);
        callback(locale, { status: '200' });
    } catch (e) {
        callback(null, { status: '404' });
    }
}

i18n.use(LanguageDetector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init(
        {
            debug: false,
            resources,
            fallbackLng: 'en', // use en if detected lng is not available

            saveMissing: true, // send not translated keys to endpoint

            keySeparator: false, // we do not use keys in form messages.welcome
            nsSeparator: false,
            interpolation: {
                escapeValue: false, // react already safes from xss
                prefix: '${',
                suffix: '}',
            },
            detection: {
                order: ['querystring', 'htmlTag', 'localStorage'],
                lookupQuerystring: 'lang',
                lookupLocalStorage: 'i18nextLng',
            },
        },
        err => {
            // console.error(err);
        }
    );

i18n.use(XHR).init({
    backend: {
        loadPath: 'locales/${lng}',
        addPath: 'locales/${lng}',
        parse: data => data,
        ajax: loadLocales,
        interpolation: {
            prefix: '${',
            suffix: '}',
        },
    },
});

export default i18n;
